import {Deserializable} from '../deserializable';
import {ChucVu} from '../danhmuc/chucvu';
import {DonVi} from '../danhmuc/donvi';
import {StaffChucVu} from './staffchucvu';
import {StaffDepartment} from './staffdepartment';


export  class Staffs implements Deserializable
{
  public  id: number;
  public  fullName: string;
  public  hoDem: string;
  public  ten: string;
  public  biDanh: string;
  public  ngaySinh: string;
  public  gioiTinh: number;
  public  maDonVi: number;
  public  chucVu: string;
  public  telOffice: string;
  public  telHome: string;
  public  mobile: string;
  public  address: string;
  public  email: string;
  public  webEmail: string;
  public  soLanDangNhap: string;
  public  chuKy: string;
  public  anh: string;
  public  thuTu: number;
  public  suDung: number;
  public  lstDonvi: string;
  public  lastAccessTime: string;
  public  chucVuItem: ChucVu;
  public  donViItem: DonVi;
  public  staffChucVuList: StaffChucVu[];
  public  staffDepartmentList: StaffDepartment[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.chucVuItem= input.chucVuItem!= null?  new ChucVu().deserialize(input.chucVuItem): null;
    this.donViItem= input.donViItem!= null? new DonVi().deserialize(input.donViItem): null;
    this.staffChucVuList = input.staffChucVuList != null ? input.staffChucVuList.map(staffChucVuList => new StaffChucVu().deserialize(staffChucVuList)) : [];
    this.staffDepartmentList = input.staffDepartmentList != null ? input.staffDepartmentList.map(staffDepartmentList => new StaffDepartment().deserialize(staffDepartmentList)) : [];
    return this;
  }
}
